<script lang="ts">
  import type { Draft, Step } from '$lib/public/wizard-state'
  interface Props {
    draft: Draft
    unitLabel: string
    onEdit: (step: Step) => void
    onSubmit: () => void
    submitting: boolean
    canSubmit: boolean
  }
  let { draft, unitLabel, onEdit, onSubmit, submitting, canSubmit }: Props = $props()
  const a = $derived(draft.assistance)
</script>

<h2 tabindex="-1">Review and submit</h2>
<p class="lead">Please confirm these details before submitting.</p>

<div class="review">
  <section>
    <div class="row">
      <h3>Animal</h3>
      <button type="button" class="link" onclick={() => onEdit('animal')}>Edit</button>
    </div>
    <p>{draft.animal.name} - {draft.animal.species}{draft.animal.color ? `, ${draft.animal.color}` : ''}</p>
  </section>
  <section>
    <div class="row">
      <h3>Status</h3>
      <button type="button" class="link" onclick={() => onEdit('status')}>Edit</button>
    </div>
    <p>{a ? a.type : 'not set'}</p>
  </section>
  <section>
    <div class="row">
      <h3>Contact</h3>
      <button type="button" class="link" onclick={() => onEdit('person')}>Edit</button>
    </div>
    <p>{draft.person.firstName} {draft.person.lastName} - {draft.person.email}</p>
  </section>
  <section>
    <div class="row">
      <h3>Unit</h3>
      <button type="button" class="link" onclick={() => onEdit('unit')}>Edit</button>
    </div>
    <p>{unitLabel}</p>
  </section>
</div>

<div class="actions">
  <button type="button" class="primary" onclick={onSubmit} disabled={submitting || !canSubmit}>
    {submitting ? 'Submitting…' : 'Submit'}
  </button>
</div>

<style>
  h2:focus {
    outline: none;
  }
  .lead {
    margin: 0 0 16px;
    color: var(--muted);
  }
  .review section {
    padding: 12px 0;
    border-top: 1px solid var(--line);
  }
  .review section:last-child {
    border-bottom: 1px solid var(--line);
  }
  .row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
  }
  .row h3 {
    margin: 0;
    font-size: 0.95rem;
  }
  .review p {
    margin: 4px 0 0;
    color: var(--ink);
  }
  button.link {
    background: none;
    border: none;
    color: var(--link);
    cursor: pointer;
    padding: 0;
    min-height: 0;
    font-size: 0.875rem;
    text-decoration: underline;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }
  button.primary {
    padding: 10px 20px;
    min-height: 44px;
    border-radius: 4px;
    font-size: 0.95rem;
    cursor: pointer;
    border: 1px solid var(--brand);
    background: var(--brand);
    color: var(--on-brand, #fff);
  }
  button.primary:disabled {
    background: color-mix(in srgb, var(--brand) 40%, var(--surface-2));
    cursor: not-allowed;
  }
</style>
